export const eventKeyConstants = {
  ARROWUP: 'ArrowUp',
  ARROWDOWN: 'ArrowDown',
  ARROWRIGHT: 'ArrowRight',
  ARROWLEFT: 'ArrowLeft',
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End',
};

export const KeyDownEvent = (event, eventCb, excSpace = false,
  excEnter = false, stopProp = false) => {
  if ((event.key === eventKeyConstants.ENTER && !excEnter)
    || (event.key === eventKeyConstants.SPACE && !excSpace)) {
    event.preventDefault();
    if (stopProp) {
      event.stopPropagation();
    }
    if (typeof eventCb === 'function') {
      eventCb();
    }
  }
}

export const KeyDownEventLink = (event, eventCb) => {
  if (event.key === eventKeyConstants.ENTER) {
    event.preventDefault();
    if (typeof eventCb === 'function') {
      eventCb();
    }
  }
}
